import { useEffect } from 'react';
import { useSegmentTracking } from 'Common/segment';
import { useSegmentTrackingInfo } from './useSegmentTrackingInfo';

const SegmentPageViewTracker = () => {
    const segmentTracker = useSegmentTracking();
    const { pageType, pageLabel, pageCategory, pageName, pathname } = useSegmentTrackingInfo();

    useEffect(() => {
        segmentTracker.page(pageCategory, pageName, {
            page_type: pageType,
            page_label: pageLabel,
        });
        // we only want to fire segment tracking if the path has changed. otherwise we will get a lot more calls
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    return null;
};

export default SegmentPageViewTracker;
